/**
 * Collects dot-notation paths where values differ between two plain objects.
 * Used to highlight form fields that have been edited compared to originalData.
 * Paths match react-hook-form field names: the content array uses numeric index
 * (content.0, content.1), not formLabel, because blueprint content is an array.
 */
import {
  getEditedContentLabels,
  getEditedPaths,
} from "@/lib/sparxs/editedPaths";
import { ADVISOR_CONTENT_FORM_PREFIX } from "./formPaths";

export { getEditedContentLabels, getEditedPaths };

export interface EditedTabs {
  content: boolean;
  advisor: boolean;
  metadata: boolean;
}

/**
 * Returns which editor tabs have edited content (by path prefix).
 * Used to show edited-state highlight on tab triggers.
 * - Content: any path under content.* (user-editable sections).
 * - Advisor: any path under advisorContent.* (editable advisor sections).
 * - Metadata: always false (metadata is display-only; no form fields).
 * Teaser is catalogue-sidecar display-only and is not part of edited state.
 */
export const getEditedTabs = (
  current: unknown,
  original: unknown,
): EditedTabs => {
  const paths = getEditedPaths(current, original);
  return {
    content: [...paths].some((p) => p.startsWith("content.")),
    advisor: [...paths].some((p) => p.startsWith(ADVISOR_CONTENT_FORM_PREFIX)),
    metadata: false,
  };
};
